import { Alert, createAlertModel } from '@akin-home/alerts';
import { Goal } from '@akin-home/goals';
import { RecurrenceMode } from '@akin-home/recurrence';
import { Frequency } from 'rrule';

export const createGoalReminder = (
  goal: Goal,
  reminder?: Partial<Alert>
): Alert =>
  createAlertModel({
    habitatID: goal.habitatID,
    goalID: goal.id,
    title: goal.title,
    emoji: goal.emoji,
    color: goal.color,
    recurrence: {
      mode: RecurrenceMode.DAILY,
      freq: Frequency.DAILY,
    },
    participant_ids: goal.participant_ids,
    ...reminder,
  });
